import * as z from 'zod'

export const forkOriginResultSchema = z.object({
  teamSlug: z.string(),
  repoSlug: z.string(),
  teamTitle: z.string(),
  repoTitle: z.string(),
})
